import { useEntities } from 'app/agriculture/queries/entities/useEntities';

/**
 * Provides Notes using Suspense.
 *
 * This hook must be called from within a SuspenseWrapper
 */
export function useNotes() {
    return useEntities('Note');
}
